import pc from "picocolors";

export function renderTextInputCursor(): string {
  return pc.white("█");
}
